import { prettyName } from '../../../utils';
import { text, type TextColumnParams } from './text';
import type { ColDefFactory, Column } from './types';
import { getFormattedCellValueColumnComparator } from './utils';

/**
 * Creates a column definition for a text column with a pretty name formatter.
 * @param {Column<TextColumnParams>} column - The column configuration.
 * @returns {ColDefFactory<Column<TextColumnParams>>} - The column definition with a pretty name formatter.
 */
export const prettyText: ColDefFactory<Column<TextColumnParams>> = column => ({
  ...text(column),
  valueFormatter: params => prettyName(params.value),
  comparator: getFormattedCellValueColumnComparator(column),
});
